<template>
      <TheFooter style="display:none">
        <div>
          <!--footer-->
          <span class="ml-1">&copy; 2019 Lyxel Labs.</span>
        </div>
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
}
</script>
